<div class="bg-footer">
  <div class="mx-1">
    <div class="py-5">
      <div class="row d-flex justify-content-center">
        <div class="col-md-3 gx-5 my-auto left-padding">
          <p>
            <a href="https://eva-mayr-stihl-stiftung.de" target="_blank">
              <img src="assets/images/eva-mayr-stihl.jpg" alt="EvaMayrStihl" width="90%" />
            </a>
          </p>
        </div>
        <div class="col-md-3 gx-5 my-auto pt-lg-6">
          <a href="https://was-essen-bei-krebs.de" target="_blank">
            <img
              src="assets/images/Logowebk.svg"
              alt="{{ 'general.title' | translate }}"
              width="72%"
            />
          </a>
        </div>
        <div class="col-md-3 gx-5 top-padding">
          <h3 class="text-color">{{ 'general.kontakt' | translate }}</h3>
          <p class="text-color">
            Eat What You Need e.V.<br />
            Goethestraße 28/1<br />
            72076 Tübingen<br />
            <a href="https://{{ 'general.contact_email' | translate }}" target="_blank">{{
              'general.contact_email' | translate
            }}</a>
          </p>
        </div>
        <div class="col-md-3 gx-5 top-padding">
          <h3 class="text-color">{{ 'general.usefull_links' | translate }}</h3>
          <p class="text-color">
            <a href="#" (click)="handleLegalNoticeClick($event)">{{
              'general.legal' | translate
            }}</a>
            <br />
            <a href="#" (click)="handlePrivacyPolicyClick($event)">{{
              'general.data_privacy' | translate
            }}</a>
            <br />
            <a href="#" (click)="handleJointResponsibilityAgreementClick($event)">{{
              'general.joint_responsibility_agreement' | translate
            }}</a>
            <br />
            <a [href]="faqUrl" target="_blank" rel="noopener">
              {{ 'general.faq' | translate }}
            </a>
          </p>
        </div>
      </div>
    </div>

    <div class="p-2">
      <p class="text-muted text-center m-0">Copyright © 2025 Eat What You Need e.V.</p>
    </div>
  </div>
</div>
